import { Card, CardContent, Grid, Skeleton, Typography } from "@mui/material"

import React from "react"

export const SkeletonCard = (props: any) => {
  return (
    <>
      <Card {...props}>
        <Grid
          container
          direction="row"
          sx={{ padding: props.padding, width: props.width }}
          justifyContent="flex-end"
          alignItems="flex-end">
          <Grid item sm={12}>
            <CardContent>
              <Typography variant="h6" gutterBottom color="primary" marginBottom={1}>
                <Skeleton />
              </Typography>
              <Typography variant="h4" gutterBottom>
                <Skeleton />
              </Typography>
              <Typography variant="bodySmall" color="textSecondary">
                <Skeleton />
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}
